import {takeLatest, put, all, call} from 'redux-saga/effects';
import * as AC from '../actions/actionTypes';
import {getCheckinsApi, getCheckinsByCustomerApi, getInvalidStatusCardsApi, getLogsApi} from '../api/reports.service';
import {errorHandler} from '../utils/errorHandler';

function* getLogsSaga(fn) {
  try {
    const response = yield call(getLogsApi, fn.filters);
    yield put({
      type: AC.GET_LOGS_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_LOGS_FAILED);
  }
}

function* getCheckinsSaga(fn) {
  try {
    const response = yield call(getCheckinsApi, fn.filters);
    yield put({
      type: AC.GET_CHECKINS_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_CHECKINS_FAILED);
  }
}

function* getCustomerCheckinsSaga(fn) {
  try{
    const response = yield call(getCheckinsByCustomerApi, fn.customerId, fn.filters);
    
    if (response && response.data) {
      yield put({
        type: AC.GET_CUSTOMERS_CHECKINS_SUCCEED,
        payload: response.data.data,
        page: response.data.page,
        totalPages: response.data.totalPages,
      });
    } else {
      console.error("Unexpected API response:", response);
      // Handle unexpected response
    }
  } catch (e){
    yield errorHandler(e, AC.GET_CUSTOMERS_CHECKINS_FAILED)
  }
}

// ------------------added this in cards saga---------------
// function* getInvalidStatusCardsSaga(fn) {
//   try {
//     const response = yield call(getInvalidStatusCardsApi, fn.filters);
//     yield put({
//       type: AC.GET_INVALID_STATUS_CARDS_SUCCEED,
//       payload: response.data, 
//     });
//   } catch (e) {
//     yield errorHandler(e, AC.GET_INVALID_STATUS_CARDS_FAILED);
//   }
// }

function* actionWatcher() {
  yield takeLatest(AC.GET_LOGS_REQUEST, getLogsSaga);
  yield takeLatest(AC.GET_CHECKINS_REQUEST, getCheckinsSaga);
  yield takeLatest(AC.GET_CUSTOMERS_CHECKINS_REQUEST, getCustomerCheckinsSaga)
}

export default function* reportsSaga() {
  yield all([actionWatcher()]);
}
